<template>
    <g v-if="menu != undefined" ref="menu" :transform="`translate(${menu.pos.x} ${menu.pos.y})`">
        <foreignObject class="contextmenu" width="1" height="1">
            <div v-if="menu.for != undefined &&'options' in menu.for" class="panel panelsquare">
                <!--<div class="menuitem" @click="flip()">Flip</div>
                <div class="menuitem" @click="rotate(-45)">Rotate Left</div>
                <div class="menuitem" @click="rotate(45)">Rotate Right</div>
                <div class="menuitem" @click="toggleLocked()">{{ menu.for.options.locked ? 'Unlock' : 'Lock'}}</div>-->
                <div class="menuitem menusquare rotateleft" @click="rotate(-45)">
                    <img src="@/../static/icons/rotate_left.svg"/>
                </div>
                <div class="menuitem menusquare rotateright" @click="rotate(45)">
                    <img src="@/../static/icons/rotate_right.svg"/>
                </div>
                <div class="menuitem menusquare" @click="flip()"> <!-- :style="`transform: rotate(${menu.for.options.rotation})`"-->
                    <div :style="`transform: rotate(${menu.for.options.rotation}deg)`">
                        <img v-if="!menu.for.options.flip" src="@/../static/icons/flip_horizontal_left.svg"/>
                        <img v-if="menu.for.options.flip" src="@/../static/icons/flip_horizontal_right.svg"/>
                    </div>
                </div>
                <div class="menuitem menusquare" @click="toggleLocked()">
                    <img v-if="menu.for.options.locked" src="@/../static/icons/locked.svg"/>
                    <img v-if="!menu.for.options.locked" class="faded" src="@/../static/icons/unlocked.svg"/>
                </div>

                <div class="auxilarybutton red" @click="destroy()">
                    <svg width="11" height="15" viewBox="0 0 11 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" d="M7.5 2C7.5 0.895386 6.60461 0 5.5 0C4.39539 0 3.5 0.895386 3.5 2H1C0.447754 2 0 2.44775 0 3C0 3.55225 0.447754 4 1 4H5.5H10C10.5522 4 11 3.55225 11 3C11 2.44775 10.5522 2 10 2H7.5ZM0.270386 7.21692C0.131592 6.59241 0.606812 6 1.24658 6H9.75342C10.3932 6 10.8684 6.59241 10.7296 7.21692L9.17407 14.2169C9.07239 14.6744 8.6665 15 8.19788 15H2.80212C2.3335 15 1.92761 14.6744 1.82593 14.2169L0.270386 7.21692Z" fill="#B4A180"/>
                    </svg>
                    <span> Delete</span>
                </div>

                
            </div>
        </foreignObject>
    </g>
</template>

<script>
import { mapGetters } from "vuex";
import { angle, distance, getSVGCoordinates } from "@/utils";

export default {
    name: 'ContextMenu',
    data() {
        return {

        };
    },
    computed: {
        ...mapGetters(["menu"]),
    },
    mounted() {
        window.addEventListener('mousedown', this.checkClickOutside)
    },
    methods: {
        checkClickOutside(e) {
            if(this.$refs.menu != undefined && !this.$refs.menu.contains(e.target)) {
                this.$store.dispatch('createContextMenu', null);
            }
        },
        flip() {
            this.$store.dispatch('updateObjectProps', [
                { id: this.menu.for.id, prop: 'options.flip', value: !this.menu.for.options.flip }
            ]);
        },
        rotate(deg) {
            this.$store.dispatch('updateObjectProps', [
                { id: this.menu.for.id, prop: 'options.rotation', value: this.menu.for.options.rotation + deg }
            ])
        },
        toggleLocked() {
            this.$store.dispatch('updateObjectProps', [
                { id: this.menu.for.id, prop: 'options.locked', value: !this.menu.for.options.locked }
            ])
        },
        destroy() {
            this.$store.dispatch('destroyObject', this.menu.for.id);
            this.$store.dispatch('createContextMenu', null);
        },
    },
};
</script>

<style>
    .contextmenu {
        overflow: visible;
        width: 1px;
        height: 1px;
    }

    .contextmenu .panel {
        min-width: 140px;
        border-top-left-radius: 0;
        user-select: none;
        border-width: 4px;
    }

    .menuitem {
        padding: 10px 20px;
        transition: all .1s ease-out;
        cursor: pointer;
    }

    .menuitem:hover {
        background-color: #FEDD8A;
    }

    .menuitem.menusquare, .menusquare * {
        width: 66px;
        height: 66px;
        margin: 0;
        padding: 0px;
        display: inline-block;
        overflow: visible;

        transition: .1s all ease-out;
    }

    /*
    .rotateleft:hover img {
        transform: rotate(-20deg);
    }
    .rotateright:hover img {
        transform: rotate(20deg);
    }*/

    .panelsquare {
        width: 140px;
        height: 140px;
        font-size: 0; /* prevent space between squares */
        position: fixed; /* fixes issue with safari */
    }

    .menusquare img.faded {
        opacity: 0.3;
    }

    .auxilarybutton {
        position: fixed;
        top: 148px;
        left: 7px;
        background-color: #FFF5E5;
        border: 3px solid #FFF5E5;
        padding: 3px 8px 1px 8px;
        border-radius: 20px;
        cursor: pointer;

        color: #B4A180;
        font-size: 16px;
        white-space: nowrap;

        transition: .05s all ease-out;
    }
    .auxilarybutton * {
        vertical-align: text-top;
    }

    .auxilarybutton:hover {
        background-color: #EFD9B3;
    }
    .auxilarybutton.red:hover {
        background-color: rgb(255, 220, 220);
        color: rgb(145, 67, 67);
    }
    .auxilarybutton.red:hover svg * {
        fill: rgb(145, 67, 67);
    }


    .fixed-wrapper {
        position: absolute;
        top: 0; left: 0;
        width: 100%;
        height: 100%;
    }
    
</style>